import { styled } from '@helvetia/components/theme'
import { colors } from '@helvetia/components/theme/colors'
import { media } from '@helvetia/components/theme/media'
import { rem } from 'polished'

export const FooterWrapper = styled.footer`
  max-width: 1360px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: 30px;

  color: ${colors.grayDark};

  padding-top: ${rem(20)};
  padding-left: ${media.onlyMobile ? rem(20) : rem(40)};
  padding-right: ${media.onlyMobile ? rem(20) : rem(40)};

  border-top: 2px solid ${colors.greyLight};
`

export const ContentLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: 'flex-start';
  align-items: center;
  margin-bottom: 50px;
`

export const LinksWrapper = styled.a`
  cursor: pointer;
  &:not(:last-child) {
    margin-right: ${rem(25)};
  }
  &:hover {
    color: ${colors.primaryDark};
  }
`
